/**
 * Service-worker registration for the FuelExpress PWA.
 *
 * Only registers in production builds (dev + preview use HMR and would loop on
 * cached bundles). Notifies the app via a custom `sw-update-ready` event when
 * a new build is waiting so we can nudge the user to reload.
 */
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  // Skip in development so hot-reload keeps working.
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      // Fires whenever a new SW is discovered.
      reg.addEventListener("updatefound", () => {
        const worker = reg.installing;
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) {
            // A new SW is waiting — surface an update prompt.
            window.dispatchEvent(new CustomEvent("sw-update-ready", { detail: { worker } }));
          }
        });
      });
    }).catch(() => { /* registration errors are non-fatal */ });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      // The active SW was replaced (usually after a user-initiated reload).
      // Nothing to do — the fresh SW is now serving.
    });
  });
}

/** Ask the waiting SW (if any) to take over immediately, then reload. */
export function skipWaitingAndReload(worker) {
  if (worker) worker.postMessage({ type: "SKIP_WAITING" });
  // Reload once the new SW takes control so the page uses fresh assets.
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  }, { once: true });
}
